module.exports = "\r\n.contact-box {\r\n    min-height: 200px;\r\n}"